
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Helper} from 'simpli-web-sdk'

@Component
export default class Sidebar extends Vue {
  menu = false
  screenWidth = window.innerWidth
  showFaturamentoSubMenu = false
  showDashboardSubMenu = false
  showNotasInseridasSubMenu = false
  showConfiguracoesGeraisSubMenu = false
  showResponsavelSubmenu = false
  showNationalGeneralConfig = false
  showInternationalGeneralConfig = false
  showInternationalUserConfig = false
  showCargaSubMenu = false

  Helper = Helper

  get isDesktop() {
    return this.screenWidth >= Number(process.env.VUE_APP_LARGE_SCREEN)
  }

  created() {
    window.addEventListener('resize', this.resizeEvent)
  }

  destroyed() {
    window.removeEventListener('resize', this.resizeEvent)
  }

  resizeEvent() {
    this.screenWidth = window.innerWidth
  }

  toggleMenu() {
    this.menu = !this.menu
  }

  menuOff() {
    this.menu = false
  }

  pushAndOpenInternationalUserSubmenu() {
    this.showInternationalUserConfig = !this.showInternationalUserConfig
    Helper.pushByName('listInternationalResponsavel')
  }
}
